<template>
  <Transition name="alert-fade">
    <div v-if="interactive_store.display_error_alert" class="error_container">
      <div class="alert alert-danger">
        <button type="button" class="close" aria-label="Close" @click="interactive_store.display_error_alert = false">
          &times;
        </button>
        <slot></slot>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { useInteractiveStore } from '@/stores/interactive'

const interactive_store = useInteractiveStore()
</script>

<style scoped>
div.error_container {
  position: fixed;
  top: 14%;
  right: 3%;
  z-index: 999;
}
div.alert {
  position: relative;
  border-radius: 7px;
  font-size: 17px;
  background-color: rgb(102, 7, 7);
  color: white;
  padding: 12px 36px 12px 16px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.15);
}
button.close {
  position: absolute;
  top: 8px;
  right: 12px;
  background: none;
  border: none;
  font-size: 23px;
  line-height: 1;
  color: white;
  opacity: 0.6;
  cursor: pointer;
  padding: 0;
  transition: opacity 0.15s;
}
button.close:hover {
  opacity: 1;
}

/* Replaces Bootstrap's fade/in classes */
.alert-fade-enter-active,
.alert-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.alert-fade-enter-from,
.alert-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>